// extracted by mini-css-extract-plugin
export default {"icon":"SwiperNavButton_icon__U1pna","iconBorder":"SwiperNavButton_iconBorder__GXXQ8","wrapper":"SwiperNavButton_wrapper__dlrAO"};